export const channels = [
  {
    id: 'ch-1',
    name: '明星绯闻',
    icon: 'ri-heart-3-line',
    desc: '恋情、行程与同框传闻的集中更新，标注已确认与待核实信息。',
    count: '每日 30+ 条',
    tone: 'primary',
  },
  {
    id: 'ch-2',
    name: '网红黑料',
    icon: 'ri-live-line',
    desc: '直播争议、售后纠纷与内容原创性讨论，保留多方说法。',
    count: '每日 20+ 条',
    tone: 'accent',
  },
  {
    id: 'ch-3',
    name: '吃瓜现场',
    icon: 'ri-chat-smile-2-line',
    desc: '综艺、剧集与活动的现场名场面，附上下文方便理解。',
    count: '每日 15+ 条',
    tone: 'secondary',
  },
  {
    id: 'ch-4',
    name: '演出动态',
    icon: 'ri-mic-line',
    desc: '巡演、音乐节与见面会的时间线整理，提醒留意官方渠道。',
    count: '每周 40+ 条',
    tone: 'primary',
  },
  {
    id: 'ch-5',
    name: '片场花絮',
    icon: 'ri-film-line',
    desc: '剧集与电影拍摄期的物料变化，番位与物料改动一目了然。',
    count: '每日 10+ 条',
    tone: 'accent',
  },
  {
    id: 'ch-6',
    name: '舆论风向',
    icon: 'ri-line-chart-line',
    desc: '热搜走势与话题热度变化，用数据看今天哪条最值得关注。',
    count: '实时更新',
    tone: 'secondary',
  },
];